import firebase from 'firebase';

const firebaseConfig = {
    apiKey: "AIzaSyAdMs2gXNYcIrBAfyO4420RmXMh4RaskCs",
    authDomain: "insideone-onereport.firebaseapp.com",
    databaseURL: "https://insideone-onereport.firebaseio.com",
    projectId: "insideone-onereport",
    storageBucket: "insideone-onereport.appspot.com",
    messagingSenderId: "289708754300",
    appId: "1:289708754300:web:7462ef37ced152a93010f9"
};

const app_one = firebase.initializeApp(firebaseConfig, 'appOne');

export default app_one;
